import { Link, Outlet, useParams } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';
import InputMask from 'react-input-mask';
import Box from 'components/ui/box';
import { useAuth } from 'context/AuthContext';
import { useEffect, useMemo, useRef, useState } from 'react';
import { getResultadosCultura, getResultadosCulturaSecond } from 'services/dashboard.service';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Avatar from 'funifier-nice-avatar';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

import { SeloColaboracao, SeloFocoNoCliente, SeloInovacao } from 'components/icons';
import { GetBehaviorDescription, GetBehaviorLabel, GetBehaviorText } from 'utils/strings';
import { TbSearch } from 'react-icons/tb';
import { BsPlusLg } from 'react-icons/bs';
import { set } from 'date-fns';
import { DestaquesCulturaDetail } from './detail';
import ReactPaginate from 'react-paginate';
import Button from 'components/ui/button';

const release = true;

const behaviorsItem = [
  {
    id: 'cooperacao',
    icon: <SeloColaboracao size={'100%'} />,
  },
  {
    id: 'integridade',
    icon: <SeloFocoNoCliente size={'100%'} />,
  },
  {
    id: 'iniciativa',
    icon: <SeloInovacao size={'100%'} />,
  },
];

const behaviorsForm = [
  {
    id: 'cooperacao',
    label: 'Cooperação',
  },
  {
    id: 'integridade',
    label: 'Integridade',
  },
  {
    id: 'iniciativa',
    label: 'Iniciativa',
  },
];

const menu = ['Ciclo 2023/1', 'Ciclo 2022/2'];

export default function DestaquesCultura() {
  const [list, setList] = useState<unknown[]>();
  const [page, setPage] = useState(0);
  const [activePag, setActivePag] = useState(0);
  const [loadingList, setLoadingList] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [showDetail, setShowDetail] = useState<any>('');
  const [selectedValue, setSelectedValue] = useState('');
  const [showMore, setShowMore] = useState({
    cooperacao: false,
    integridade: false,
    iniciativa: false,
  });

  const behaviors: any = useMemo(() => {
    return {
      cooperacao: {
        id: 'cooperacao',
        icon: <SeloColaboracao size={'100%'} year={activeTab === 1 ? 2022 : undefined} />,
      },
      integridade: {
        id: 'integridade',
        icon: <SeloFocoNoCliente size={'100%'} year={activeTab === 1 ? 2022 : undefined} />,
      },
      iniciativa: {
        id: 'iniciativa',
        icon: <SeloInovacao size={'100%'} year={activeTab === 1 ? 2022 : undefined} />,
      },
    };
  }, [activeTab]);

  const [mask] = useState('');

  const searchRef = useRef<any>();

  const params = useParams();

  const { user } = useAuth();

  function handleDetail(item: any) {
    setShowDetail(item);
  }

  const handleChange = (event: any) => {
    setSelectedValue(event.target.value ? event.target.value : '');
  };

  async function loadData(e?: any, itemPage?: number) {
    if (e) {
      e.preventDefault();
    }

    try {
      if (activeTab === 0) {
        const rangeItem = itemPage ? itemPage * 20 : 0;

        setActivePag(itemPage ? itemPage : 0);
        setLoadingList(true);
        setList([]);

        const data = await getResultadosCulturaSecond(
          searchRef.current.value,
          selectedValue ? selectedValue : undefined,
          rangeItem,
        );

        setPage(data.range.pages);
        setList(data.result);
        setLoadingList(false);
      } else if (activeTab === 1) {
        const rangeItem = itemPage ? itemPage * 20 : 0;

        setActivePag(itemPage ? itemPage : 0);
        setLoadingList(true);
        setList([]);

        const data = await getResultadosCultura(searchRef.current.value, selectedValue ? selectedValue : undefined, rangeItem);

        setPage(data.range.pages);
        setList(data.result);
        setLoadingList(false);
      }
    } catch (e) {}
  }

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, selectedValue]);

  // useEffect(() => {
  //   if (!list) return;
  //   setLoad(true);
  //   const data = list.filter(
  //     (item: any) => item.behavior === behaviors[activeTab].id
  //   );
  //   setListFiltered(data);

  //   setLoad(false);
  // }, [activeTab, list, setListFiltered]);

  if (!!showDetail)
    return (
      <DestaquesCulturaDetail
        onClose={() => setShowDetail('')}
        behavior={showDetail.behavior}
        id={showDetail.matricula}
        grupo={showDetail.grupo}
        funcis={showDetail.membros}
        active={activeTab}
      />
    );

  return (
    <>
      {!params.id ? (
        <div className="mx-auto container p-3 lg:p-10 overflow-hidden">
          <div className="mb-3 lg:mb-10 flex justify-between">
            <div className="flex flex-ro items-center space-x-3 lg:space-x-1">
              <div>
                <Link to="../">
                  <button className="rounded-full bg-purple flex justify-center items-center p-1">
                    <RiArrowLeftSLine size={28} className="text-white" />
                  </button>
                </Link>
              </div>

              <h1 className="text-lg lg:text-3xl  py-1 px-6 rounded-full">Destaques da Cultura</h1>
            </div>
          </div>

          <div className="flex justify-between items-center lg:hidden mb-10">
            <Button
              color="clear"
              className="shadow-none pr-0 pl-0"
              disabled={activeTab < 1}
              onClick={() => setActiveTab(activeTab - 1)}
            >
              <IoIosArrowBack className={`text-grey-dark ${activeTab === 0 && 'bg-opacity-5'}}`} size={24} />
            </Button>

            <p className="text-xl font-bold text-yellow">{menu[activeTab]}</p>

            <Button
              color="clear"
              className="shadow-none pr-0 pl-0"
              disabled={activeTab > 0}
              onClick={() => setActiveTab(activeTab + 1)}
            >
              <IoIosArrowForward className={`text-grey-dark ${activeTab > 0 && 'opacity-5'}}`} size={24} />
            </Button>
          </div>

          <div className="w-full hidden lg:flex flex-col space-y-5 mt-10">
            <div className="rounded-xl overflow-hidden  items-center justify-between mb-12 flex">
              <button
                className={`${
                  activeTab === 0 ? 'bg-slate-blue' : 'bg-maastricht-blue'
                } w-6/12 h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center`}
                onClick={() => setActiveTab(0)}
              >
                Ciclo 2023/1
              </button>
              <button
                className={`${
                  activeTab === 1 ? 'bg-slate-blue' : 'bg-maastricht-blue'
                } w-6/12 h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center`}
                onClick={() => setActiveTab(1)}
              >
                Ciclo 2022/2
              </button>
            </div>
          </div>

          <div className="space-y-5 mb-5">
            <div className="grid lg:grid-cols-2 gap-3 w-full">
              <Box>
                <div className="space-y-5">
                  <div className="flex flex-row items-center space-x-5 rounded-xl">
                    <div className="w-[100px] cursor-pointer" onClick={() => setSelectedValue('cooperacao')}>
                      <SeloColaboracao size={'100%'} year={activeTab === 1 ? 2022 : undefined} />
                    </div>
                    <div className="flex-1">
                      <div>
                        <p className="text-blue-light">
                          A palavra “colaboração” significa trabalho em conjunto e é a soft skill do momento!
                        </p>

                        <p>
                          A colaboração é essencial para que todos se relacionem de forma{' '}
                          <a
                            className="text-yellow hover:text-yellow"
                            href="https://blog.betrybe.com/carreira/pensamento-sistemico/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            harmônica
                          </a>
                          . E faz com que todo o time cresça. Com colaboração, os resultados são alcançados muito mais rapidamente
                          e com maior efetividade.
                        </p>

                        {showMore.cooperacao && (
                          <p>
                            Você está com uma semana intensa de trabalho e o colega que está ao seu lado se dispôs a auxiliá-lo?
                            Esse é o espírito da colaboração! Bora acessar o Reconheça BRB para reconhecer esse comportamento?
                          </p>
                        )}
                        <div className="flex w-full justify-end">
                          <button
                            className="font-thin underline hover:no-underline text-electric-blue"
                            onClick={() =>
                              setShowMore(prev => ({
                                ...prev,
                                cooperacao: !prev.cooperacao,
                              }))
                            }
                          >
                            {showMore.cooperacao ? 'Mostrar menos' : 'Mostrar mais'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Box>

              <Box>
                <div className="space-y-5">
                  <div className="flex flex-row items-center space-x-5 rounded-xl">
                    <div className="w-[100px] cursor-pointer" onClick={() => setSelectedValue('integridade')}>
                      <SeloFocoNoCliente size={'100%'} year={activeTab === 1 ? 2022 : undefined} />
                    </div>
                    <div className="flex-1">
                      <div>
                        <p className="text-blue-light">Ser próximo e proativo para encantar o cliente.</p>

                        <p>
                          Foco no cliente é prestar atendimento humanizado, sentir empatia, oferecer soluções de acordo com as
                          necessidades, responder com celeridade e resolutividade. Só é preciso lembrar que cliente pode ser um
                          colega da mesma ou de outra área, um cliente correntista ou investidor, um acionista, ou seja, toda
                          pessoa envolvida de alguma forma com a gente.
                        </p>

                        {showMore.integridade && (
                          <p>
                            Seu colega encantou um cliente com um atendimento exemplar? Ele merece gigabytes no Reconheça BRB por isso!
                            <br />
                            <br />
                            <span className="text-yellow text-light">#Resultado é gerar valor para o cliente.</span>
                          </p>
                        )}
                        <div className="flex w-full justify-end">
                          <button
                            className="font-thin underline hover:no-underline text-electric-blue"
                            onClick={() =>
                              setShowMore(prev => ({
                                ...prev,
                                integridade: !prev.integridade,
                              }))
                            }
                          >
                            {showMore.integridade ? 'Mostrar menos' : 'Mostrar mais'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Box>

              <Box>
                <div className="space-y-5">
                  <div className="flex flex-row items-center space-x-5 rounded-xl">
                    <div className="w-[100px] cursor-pointer" onClick={() => setSelectedValue('iniciativa')}>
                      <SeloInovacao size={'100%'} year={activeTab === 1 ? 2022 : undefined} />
                    </div>
                    <div className="flex-1">
                      <div>
                        <p className="text-blue-light">Inovar é a arte de pensar fora da caixa, de fazer diferente.</p>

                        <p>
                          Inovar é introduzir novidades ou realizar algo que nunca havia sido feito antes. É achar soluções
                          simples para os temas cotidianos. A inovação pode ser para a empresa, para a equipe, para o mercado ou
                          para o mundo.
                        </p>

                        {showMore.iniciativa && (
                          <p>
                            Sabe aquele colega que teve uma ideia genial para descomplicar o dia a dia ou para resolver um
                            problema complexo? Reconhecê-lo no Reconheça BRB é uma atitude inovadora também. Bora fazer?
                            <br />
                            <br />
                            <span className="text-yellow text-light">#Buscamos o novo todos os dias.</span>
                          </p>
                        )}
                        <div className="flex w-full justify-end">
                          <button
                            className="font-thin underline hover:no-underline text-electric-blue"
                            onClick={() =>
                              setShowMore(prev => ({
                                ...prev,
                                iniciativa: !prev.iniciativa,
                              }))
                            }
                          >
                            {showMore.iniciativa ? 'Mostrar menos' : 'Mostrar mais'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Box>
            </div>
          </div>

          <div className="lg:flex justify-between">
            <div className="w-full lg:w-[50%] flex justify-end mb-5 lg:mb-0">
              <select
                className="w-[40%] bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
                value={selectedValue}
                onChange={handleChange}
              >
                <option value="">Todos comportamentos</option>
                {behaviorsForm.map(behavior => (
                  <option key={behavior.id} value={behavior.id}>
                    {behavior.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="space-x-4 flex flex-row items-center justify-between">
              <form onSubmit={e => loadData(e)} className="pl-1 -ml-1 flex-1">
                <InputMask
                  placeholder="Pesquise com nome ou e-mail"
                  alwaysShowMask={false}
                  mask={mask}
                  ref={(ref: any) => {
                    searchRef.current = ref;
                  }}
                  inputMode="search"
                  style={{ fontSize: 16 }}
                  className="min-w-full lg:min-w-[416px] bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
                />
              </form>

              <TbSearch size={28} className="cursor-pointer hover:ring-2 mr-1 rounded-full" onClick={() => loadData()} />
            </div>
          </div>

          {!release ? (
            <Box>
              <div className="space-y-5 lg:p-3">
                <div className="text-center">
                  <h3 className="text-xl">Em breve</h3>
                </div>
              </div>
            </Box>
          ) : null}
          {release ? (
            <div className="space-y-5 pt-5">
              {loadingList && (
                <div className="space-y-2">
                  <ArticlePlaceholder />
                  <ArticlePlaceholder />
                </div>
              )}

              <div className={`${loadingList && 'hidden'} space-y-2`}>
                <div className="flex flex-col space-y-5">
                  {/* <div className="space-y-5">
                      <div className="flex flex-row items-center bg-maastricht-blue-3 p-5 space-x-5 rounded-xl">
                        <div className="w-[114px]">
                          {behaviors[activeTab].icon}
                        </div>
                        <div className="flex-1">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: GetBehaviorText(behaviors[activeTab].id),
                            }}
                          ></div>
                        </div>
                      </div> */}

                  <Box>
                    {!loadingList && list?.length === 0 && (
                      <div className="text-center">
                        <h3 className="text-xl">Nenhum resultado encontrado</h3>
                      </div>
                    )}

                    <div className="space-y-2">
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        {list?.map((item: any, index) => (
                          <div
                            className="bg-maastricht-blue rounded-xl text-white space-y-2 cursor-pointer hover:ring-2 h-fit"
                            key={item?._id + '-' + item.behavior + index}
                            onClick={() => handleDetail(item)}
                          >
                            <div className="px-4 relative">
                              <div className="flex flex-col items-center justify-around md:h-40 space-y-1 text-center">
                                <div className="w-28 h-28 overflow-hidden rounded-full bg-purple text-3xl font-bold flex flex-row items-center justify-center">
                                  {!!item.avatar_type &&
                                    (item.image ? (
                                      <img src={item.image} alt={item.nome} className="w-full h-full" />
                                    ) : (
                                      item.nome[0]
                                    ))}
                                  {!item.avatar_type &&
                                    (!!item.avatar ? <Avatar className="w-full h-full" {...item.avatar} /> : item.nome[0])}
                                </div>

                                <div className="w-20 absolute -top-3 -right-3">{behaviors[item.behavior].icon}</div>
                              </div>
                            </div>

                            <div className="bg-prussian-blue-3 w-full  text-center pb-7 pt-5 rounded-b-xl h-[55%]">
                              <div className="font-bold">{item.nome}</div>
                              <div className="mt-1">
                                <span className="text-electric-blue font-thin">{item.diretoria} </span>
                                <span className="font-thin">- {item.funcao}</span>
                              </div>
                              <div className="text-electric-blue mb-3">
                                <span className="font-thin">{item.matricula}</span>
                                <br />
                                <span>Grupo: {item.grupo}</span>
                              </div>

                              <button className="mt-4">
                                <BsPlusLg className="mr-2 inline-block" size={17} color="#C2D2FF" />
                                <span className="uppercase">Ver mais</span>
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className={`flex justify-center mt-5 ${page < 2 && 'hidden'}`}>
                      <ReactPaginate
                        activeClassName={'item active '}
                        breakClassName={'item break-me '}
                        breakLabel={'...'}
                        containerClassName={'pagination'}
                        disabledClassName={'disabled-page'}
                        nextClassName={'item next '}
                        pageClassName={'item pagination-page '}
                        previousClassName={'item previous'}
                        initialPage={0}
                        forcePage={activePag}
                        nextLabel={<IoIosArrowForward style={{ fontSize: 18, width: 150 }} />}
                        onPageChange={data => loadData(null, data.selected)}
                        pageRangeDisplayed={3}
                        pageCount={page}
                        previousLabel={<IoIosArrowBack style={{ fontSize: 18, width: 150 }} />}
                      />
                    </div>
                  </Box>
                  {/* </div> */}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
      <Outlet />
    </>
  );
}
